import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import { useEffect, useState } from "react";
import { HDLModuleWASM } from "./sim/hdlwasm";
import ToggleButtonGroup from "@mui/joy/ToggleButtonGroup";
import { FancyButton } from "./fancy_button";
import { SimOutputKind } from "./simulation_options";
import { TTInput } from "./tinytapeout_simulation";

export function Switches({ switchCount, switches, setSwitches}: { switchCount: number, switches: number, setSwitches: (arg0: number) => void}) {
  // Cursedness: 87%. The ToggleButtonGroup looks pretty, but it works with strings,
  // one for each button, not an array of pressed buttons or anything. We'll work
  // around that by generating buttons with the correct 'value' string for each digit,
  // then translate between an array of strings like ["1", "3", "4"] and the binary repr
  // in this case 0b0101_1000
  if (switchCount) {
    return (
      <Box>
        <span>Switches:</span>
        <ToggleButtonGroup
          value={[...Array(switchCount).keys()]
            .filter((num) => {
              return ((switches >> num) & 1) == 1
            })
            .map((num) => num.toString())
          }
          onChange={
            (_, newValue) => {
              let newValueInt = 0
              for (const digit of newValue) {
                newValueInt = newValueInt | (1 << parseInt(digit))
              }
              setSwitches(newValueInt)
            }
          }
        >
          {[...Array(switchCount).keys()].map((num) => {
            return <Button value={num.toString()}>{num}</Button>
          })}
        </ToggleButtonGroup>
      </Box>
    )
  }
}


function Buttons({ count, setButtons }: { count: number, setButtons: (arg0: number) => void }) {
  if (count) {
    return <Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: "3px" }}>
        {[...Array(count).keys()].map((num) => {
          console.log(num)
          return <FancyButton
            onPointerDown={() => {
              setButtons((1 << num))
            }}
            onPointerUp={() => {
              setButtons(0)
            }}
            key={num}
          />
        })}
      </Box>
    </Box>
  }
}




export function DefaultInputs({hdlMod, running}: {hdlMod: HDLModuleWASM, running: boolean}) {
  const [switches, setSwitches] = useState<number>(0)
  const [buttons, setButtons] = useState<number>(0)
  const [inputHelpOpen, setInputHelpOpen] = useState(false);

  
  function buttonCount(): number {
    const btn = hdlMod?.globals.vars.btn
    if (btn) {
      return (btn.type.left - btn.type.right) + 1;
    } else {
      return null
    }
  }

  function switchCount(): number {
    const sw = hdlMod?.globals.vars.sw
    if (sw) {
      return (sw.type.left - sw.type.right) + 1;
    } else {
      return null
    }
  }

  useEffect(() => {
    if (hdlMod) {
      hdlMod.state.btn = buttons;
      hdlMod.state.sw = switches;
    }
  }, [hdlMod, buttons, switches])
  
  function InputHelp() {
    const help = <Box>
      <p>Inputs are automatically added based on the inputs to your top module.</p>
      <ul>
        <li> To add switches, add an input called <code>sw</code></li>
        <li> To add buttons, add an input called <code>btn</code></li>
      </ul>
      <p> Make sure those inputs are marked <code>#[no_mangle]</code></p>
    </Box>
    if (!switchCount() && !buttonCount()) {
      return help
    } else {
      return <Box>
        <p></p>
        <Button
          size='lg'
          variant='outlined'
          startDecorator={<QuestionMarkIcon />}
          loading={running}
          onClick={() => setInputHelpOpen(!inputHelpOpen)}
        >
          Inputs
        </Button>
        {inputHelpOpen ? help : <Box />}
      </Box>

    }
  }

  return <Box>
    <Switches switches={switches} setSwitches={setSwitches} switchCount={switchCount()}/>
    <Buttons count={buttonCount()} setButtons={setButtons} />
    <InputHelp />
  </Box>
}

export const Inputs = ({simKind, hdlMod, running}: {simKind: SimOutputKind, hdlMod: HDLModuleWASM, running: boolean}) => {
  switch (simKind.kind) {
    case "VGA":
    case "LED":
      return <DefaultInputs hdlMod={hdlMod} running={running}/>;
    case "TinyTapeout":
      // Tinytapeout places its things itself
      // return <TTInput hdlMod={hdlMod}/>;
  }
}
  

